import { h } from 'preact';
import CategoryList from '@ui/Archive/CategoryList';
import NumberOfHits from '@features/elastic/components/NumberOfHits';

export default function ArchiveHeader({
    name,
    description,
    subCategories,
    showSearchQuery,
    imageUrl,
    imageAlt,
}) {
    const showSubCategories = (subCategories && subCategories.length > 0);
    const showImage = imageUrl && !!imageUrl.trim()

    return (
        <header className="page-title">
            <div className="page-title__left">
                {name && (<h1>{name}</h1>)}
                {description && (<div className="archive__description" dangerouslySetInnerHTML={{ __html: description }} />)}
                {showSubCategories && (<CategoryList categories={subCategories} />)}
                {showSearchQuery && (<NumberOfHits />)}
            </div>
            
            {showImage && (
                <div className="page-title__right">
                    <img
                        className="archive-image"
                        src={imageUrl}
                        alt={imageAlt}
                    />
                </div>
            )}
        </header>
    );
}